function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/no-static-element-interactions */


import * as React from 'react';

var MobileMenu = function (_React$Component) {
  _inherits(MobileMenu, _React$Component);

  function MobileMenu() {
    _classCallCheck(this, MobileMenu);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  MobileMenu.prototype.render = function render() {
    var _props = this.props,
        headerRight = _props.headerRight,
        headerCenter = _props.headerCenter,
        items = _props.items,
        footer = _props.footer,
        onNavigate = _props.onNavigate,
        onToggleNavMenu = _props.onToggleNavMenu,
        navMenuOpen = _props.navMenuOpen;
    return React.createElement('nav', {
      className: 'mobile-menu ' + (navMenuOpen ? 'open' : '')
    }, React.createElement('header', {
      className: 'mobile-menu__header'
    }, React.createElement('button', {
      className: 'mobile-menu__button ' + (navMenuOpen ? 'open' : ''),
      onClick: onToggleNavMenu
    }, React.createElement('span', null)), headerCenter, headerRight), React.createElement('div', {
      className: 'mobile-menu__dropdown ' + (navMenuOpen ? 'open' : '')
    }, React.createElement('div', {
      onClick: onNavigate
    }, items), footer));
  };

  return MobileMenu;
}(React.Component);

export default MobileMenu;